
import {routerPaths} from '../../../router/routerPaths'
// import permissions from "../../../router/middleware/permissions";
// import {PERMISSIONS} from "../../../staticData/permissionsStatic";

const OrderScalesTable = () => import(/* webpackChunkName: "group-order-scales" */ './components/OrderScalesTable/OrderScalesTable.vue')
const moduleKey = 'order-scales'


export const OrderScalesRoutes = [
  {
    path: routerPaths.orderScales,
    component: OrderScalesTable,
    meta: {
      breadcrumbs: {
        key: [
          'menu_finance',
          'mainSettingsOrderScales'
        ],
        items: {
          'menu_finance': {
            name: 'menu_ordersDispatches',
            link: routerPaths.orderScales,
          },
          'mainSettingsOrderScales': {
            name: 'menu_orderScales',
            link: routerPaths.orderScales,
          },
        },
      },

      // middleware: [permissions],
      // permissions: [PERMISSIONS.FORBIDDEN_PAYMENT_GENERAL],

      moduleKey: moduleKey,
      pageTitle: 'menu_orderScales'
    },
  }
]
